<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-mirror`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25 2a1 1 0 011 1v42a1 1 0 01-1 1h-2a1 1 0 01-1-1V3a1 1 0 011-1h2zM5 11.204a1 1 0 01.659.247l13.48 11.796a1 1 0 010 1.506L5.66 36.549A1 1 0 014 35.796V12.204a1 1 0 011-1zm39 1a1 1 0 00-1.658-.753L28.86 23.247a1 1 0 000 1.505L42.342 36.55A1 1 0 0044 35.796V12.204zM8 29.184L13.926 24 8 18.815v10.37zM34.074 24L40 18.815v10.37L34.074 24z"/></svg>
</template>
<script>

export default {
  name: 'IconMirror',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
